// Display helpers in the active company's time zone (Bad Ass: America/Edmonton), never the browser's. DST handled by Intl.
export const companyTz = () => window.__auctionTz || "America/Edmonton";
const cache = {};
const F = (key, opts, locale = "en-US") => {
  const tz = companyTz();
  const k = `${key}|${tz}`;
  if (!cache[k]) cache[k] = new Intl.DateTimeFormat(locale, { timeZone: tz, ...opts });
  return cache[k];
};
const D = () => F("d", { month: "short", day: "numeric", year: "numeric" });
const T = () => F("t", { hour: "numeric", minute: "2-digit", timeZoneName: "short" });
const W = () => F("w", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
const ok = (v) => v && !Number.isNaN(new Date(v).getTime());
// Alberta: permanent Alberta Time (UTC-6) from 2026-11-01; browsers label it "CST" or "GMT-6", customers know it as ABT.
const ab = (s) => (companyTz() === "America/Edmonton" ? s.replace(/\b(CST|GMT-6|UTC-6)\b/, "ABT") : s);
export const timeMT = (v) => (ok(v) ? ab(T().format(new Date(v))) : "");
export const dayMT = (v) => (ok(v) ? W().format(new Date(v)) : "");
export const fmtMT = (v) => (ok(v) ? `${D().format(new Date(v))} · ${ab(T().format(new Date(v)))}` : "");
export const todayCompany = () => F("iso", {}, "en-CA").format(new Date());
const FMT = () => F("parts", { hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }, "en-CA");
const parts = (ms) => Object.fromEntries(FMT().formatToParts(new Date(ms)).map((p) => [p.type, p.value]));

// UTC instant (ms) of a company wall-clock date + "HH:MM" (DST-aware).
export const mtToUtc = (dateIso, hhmm) => {
  const [y, m, d] = dateIso.split("-").map(Number);
  const [h, mi] = hhmm.split(":").map(Number);
  const want = Date.UTC(y, m - 1, d, h, mi);
  let ms = want;
  for (let i = 0; i < 3; i += 1) {
    const p = parts(ms);
    ms += want - Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
  }
  return ms;
};

// Bidding Starts = exactly `hours` elapsed hours before the close, in company wall time.
export const autoStart = (closeIso, closeTime, hours = 36) => {
  const p = parts(mtToUtc(closeIso, closeTime) - hours * 3600 * 1000);
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${String(+p.hour % 24).padStart(2, "0")}:${p.minute}` };
};

export const timeLabel = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};
